/* scroll animations plugin */
(function($) {
    $.fn.animateIn = function(options) {
        return this.each(function() {
            var settings = $.extend(
                {
                    //default settings
                    offset: 0,
                    modifier: '__in'
                },
                options
            );

            var item = $(this);
            var triggerVal = item.offset().top + settings.offset;

            function animateBlock() {
                var scrollTop = $(window).scrollTop();
                var windowHeight = $(window).outerHeight();

                // Check if element is in view
                if (scrollTop + windowHeight >= triggerVal) {
                    item.addClass(settings.modifier);
                    $(window).off('scroll', animateBlock); // Remove event after animating
                }
            }

            // Initial check on page load
            animateBlock();

            // Debounced scroll event
            $(window).on('scroll', debounce(animateBlock, 100));
        });
    };

    function debounce(func, wait) {
        let timeout;
        return function () {
            clearTimeout(timeout);
            timeout = setTimeout(func, wait);
        };
    }
})(jQuery);
